var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSmartphone = function SvgSmartphone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.595 58H7.405C5.525 58 4 56.475 4 54.595V3.405C4 1.525 5.525 0 7.405 0H32.594C34.475 0 36 1.525 36 3.405V54.594C36 56.475 34.475 58 32.595 58Z",
    fill: "#CBCFD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 6H4V46H36V6Z",
    fill: "#E7ECED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 55C21.6569 55 23 53.6569 23 52C23 50.3431 21.6569 49 20 49C18.3431 49 17 50.3431 17 52C17 53.6569 18.3431 55 20 55Z",
    fill: "#262B35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H16C15.447 4 15 3.553 15 3C15 2.447 15.447 2 16 2H20C20.553 2 21 2.447 21 3C21 3.553 20.553 4 20 4Z",
    fill: "#262B35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 4H23C22.447 4 22 3.553 22 3C22 2.447 22.447 2 23 2H24C24.553 2 25 2.447 25 3C25 3.553 24.553 4 24 4Z",
    fill: "#262B35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54 15C54 13.3431 52.6569 12 51 12H21C19.3431 12 18 13.3431 18 15V28C18 29.6569 19.3431 31 21 31C21.5523 31 22 31.4477 22 32V35C22 35.824 22.9408 36.2944 23.6 35.8L28.4 32.2C29.4386 31.4211 30.7018 31 32 31H51C52.6569 31 54 29.6569 54 28V15Z",
    fill: "#CBCFD2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20H34C34.552 20 35 19.553 35 19C35 18.447 34.552 18 34 18H24C23.448 18 23 18.447 23 19C23 19.553 23.448 20 24 20Z",
    fill: "#FFCB05"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23H24C23.448 23 23 23.447 23 24C23 24.553 23.448 25 24 25H48C48.552 25 49 24.553 49 24C49 23.447 48.552 23 48 23Z",
    fill: "#FFCB05"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmartphone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smartphone.0d6359a2.svg";
export { ForwardRef as ReactComponent };